import Vue from 'vue';

const Components = require.context('./', true, /\.vue/);
const ComponentArr = Components.keys().map(item => {
  return {
    install(Vue) {
      Vue.component(Components(item).default.name, Components(item).default);
    }
  };
});

ComponentArr.length > 0 && ComponentArr.forEach(item => Vue.use(item));
